export const CANCELLATION_ENTRY_POINT = {
  activePlan: 'web_active_plan',
  manageSubscriptions: 'web_manage_subscriptions'
};

export const CANCELLATION_OUTCOME = {
  abandoned: 'abandoned',
  retained: 'retained',
  leftForPortal: 'left_for_portal',
  confirmed: 'confirmed'
};
